<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="72%"
    append-to-body
    @close="handleClose"
  >
    <div style="height: 360px; overflow-y: scroll">
      <el-table
        size="small"
        :data="data"
        highlight-current-row
        border
        element-loading-text="拼命加载中"
        style="width: 100%"
      >
        <el-table-column align="center" label="操作" width="240">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="customerName"
          label="客户名称"
          width="140px"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="acceptorName"
          label="承兑人"
          width="140px"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="faceValue"
          label="票面金额（万）"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="入库日期" prop="createDate"> </el-table-column>
        <el-table-column label="出库日期" prop="outDate"> </el-table-column>
        <el-table-column label="拟售价（元）" prop="preSale">
          <template slot-scope="props">
            <el-input-number
              :min="0"
              :controls="false"
              size="small"
              v-model="props.row.preSale"
              placeholder="每十万扣款"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="瑕疵" prop="inPercentage"></el-table-column>
      </el-table>
    </div>
    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateBatchPresaleForTicket } from "@/api/ticket/ticket";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleDelete(index) {
      this.data.splice(index, 1);
    },
    handleSubmit() {
      updateBatchPresaleForTicket(this.data)
        .then((data) => {
          this.$message.success("操作成功");
          this.handleClose();
        })
        .catch(this.$message.warning);
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("confirm");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ticket/ticket-estimate/batch.vue